import {
  ScheduledConsultationTypeDTO,
  type ConsultationRequestDTO,
  type ScheduledConsultationDTO,
  type ScheduledConsultationSummaryDTO,
  type DirectConsultationSummaryDTO
} from '@/generated'

export function isScheduledConsultation(
  consultation: ScheduledConsultationDTO | ConsultationRequestDTO
): consultation is ScheduledConsultationDTO {
  return (
    'type' in consultation &&
    Object.values(ScheduledConsultationTypeDTO).includes(consultation.type)
  )
}

export function isScheduledConsultationSummary(
  consultation: ScheduledConsultationSummaryDTO | DirectConsultationSummaryDTO
): consultation is ScheduledConsultationSummaryDTO {
  return (
    'scheduledType' in consultation &&
    Object.values(ScheduledConsultationTypeDTO).includes(consultation.scheduledType)
  )
}
